var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinutesHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.4545mm",
    height: "149.42mm",
    viewBox: "0 0 7.4545455 149.42343",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.291 92.188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -332.93 -160.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1372.8,
    y: 257.55,
    width: 28.175,
    height: 564.75,
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.71868 0 0 .89577 1124.7 143.01)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.87 220.87 2.0282 6.6495 11.407 224.57-13.435 12.728z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.87 220.87-2.0282 6.6495-11.407 224.57 13.435 12.728z",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutesHand);
export default __webpack_public_path__ + "static/media/minutes_hand.00d5292ef5b0c41ce57c8eb581f070cf.svg";
export { ForwardRef as ReactComponent };